import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import Loading from "../../Components/Loading";
import { Button, ButtonGroup, Form } from "react-bootstrap";
import Dialog from "../../Components/Dialog";
import KakaoAddress from "../../Components/Kakao/DaumPostCode";
import Swal from "../../Components/SweetAlert2";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function HealthDocument() {
  const navigate = useNavigate();
  const location = useLocation();
  const language = useSelector((state) => state.localStorage.language);
  const authorization = useSelector((state) => state.localStorage.authorization);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [formData, setFormData] = useState({
    jobDate: "", // 작업 예정일
    siteId: "",
    siteName: "",
    eduId: "",
    constructionTypeList: [],
    constructionTypes: [],
    unitList: [],
    units: [],
    address: "", // 주소
    emergencyPhone: "", // 비상연락처
    highBloodPressure: "", // 최고 혈압
    lowBloodPressure: "", // 최저 혈압
    workExperience: "0", // 경력
    smoking: "0", // 흡연 여부
    drinking: "0", // 음주 여부
    healthCheck: [],
    ppeIssueStatus: [],
    safeAgreement: [],
    pledgeConfirmed: false, // 안전 서약서 동의 여부
  });
  const [dialog, setDialog] = useState(false); // 안전 서약서 동의 다이얼로그
  const [dialog1, setDialog1] = useState(false); // 주소 검색 다이얼로그
  const [wording, setWording] = useState({
    placeholder1: "기타를 입력하세요.",
    placeholder2: "비상연락처를 입력하세요.",
    placeholder3: "클릭하면 주소검색 창이 나옵니다.",
    placeholder4: "최고 혈압을 입력하세요.",
    placeholder5: "최저 혈압을 입력하세요.",
    label: "동의합니다.",
  });

  const [selectOptions, setSelectOptions] = useState({
    workExperience: {
      select: "경력을 선택하세요.",
      lessThan1Month: "1개월 미만",
      lessThan3Months: "3개월 미만",
      lessThan6Months: "6개월 미만",
      lessThan1Year: "1년 미만",
      lessThan3Years: "3년 미만",
      lessThan5Years: "5년 미만",
      moreThan5Years: "5년 이상",
    },
    smoking: {
      select: "흡연 여부를 선택하세요.",
      smoker: "흡연",
      nonSmoker: "비흡연",
    },
    drinking: {
      select: "음주 여부를 선택하세요.",
      drinker: "음주",
      nonDrinker: "비음주",
    },
  });

  useEffect(() => {
    console.log("location.state: ", location.state);
    Init();
  }, []);

  useEffect(() => {
    if (!authorization.auth) {
      navigate("/");
    }
  }, [authorization.auth]);

  const Init = async () => {
    try {
      const userData = await IndexedDb.GetUserInfo();
      console.log("userData: ", userData);
      setUserInfo(userData);
      setFormData({
        ...formData,
        siteId: location.state.site?.siteId,
      });
      const searchResult = await Search(userData.userId);
      // Search 함수가 완료된 후 Search1 함수들 호출
      await Search1("health", searchResult);
      await Search1("ppe", searchResult);
      await Search1("agreement", searchResult);
      const _placeholder1 = await TranslationService.translateText(wording.placeholder1, language.lang);
      const _placeholder2 = await TranslationService.translateText(wording.placeholder2, language.lang);
      const _placeholder3 = await TranslationService.translateText(wording.placeholder3, language.lang);
      const _placeholder4 = await TranslationService.translateText(wording.placeholder4, language.lang);
      const _placeholder5 = await TranslationService.translateText(wording.placeholder5, language.lang);
      const _label = await TranslationService.translateText(wording.label, language.lang);
      setWording({ ...wording, placeholder1: _placeholder1, placeholder2: _placeholder2, placeholder3: _placeholder3, placeholder4: _placeholder4, placeholder5: _placeholder5, label: _label });

      // select 옵션들 번역
      const _workExperienceSelect = await TranslationService.translateText(selectOptions.workExperience.select, language.lang);
      const _lessThan1Month = await TranslationService.translateText(selectOptions.workExperience.lessThan1Month, language.lang);
      const _lessThan3Months = await TranslationService.translateText(selectOptions.workExperience.lessThan3Months, language.lang);
      const _lessThan6Months = await TranslationService.translateText(selectOptions.workExperience.lessThan6Months, language.lang);
      const _lessThan1Year = await TranslationService.translateText(selectOptions.workExperience.lessThan1Year, language.lang);
      const _lessThan3Years = await TranslationService.translateText(selectOptions.workExperience.lessThan3Years, language.lang);
      const _lessThan5Years = await TranslationService.translateText(selectOptions.workExperience.lessThan5Years, language.lang);
      const _moreThan5Years = await TranslationService.translateText(selectOptions.workExperience.moreThan5Years, language.lang);

      const _smokingSelect = await TranslationService.translateText(selectOptions.smoking.select, language.lang);
      const _smoker = await TranslationService.translateText(selectOptions.smoking.smoker, language.lang);
      const _nonSmoker = await TranslationService.translateText(selectOptions.smoking.nonSmoker, language.lang);

      const _drinkingSelect = await TranslationService.translateText(selectOptions.drinking.select, language.lang);
      const _drinker = await TranslationService.translateText(selectOptions.drinking.drinker, language.lang);
      const _nonDrinker = await TranslationService.translateText(selectOptions.drinking.nonDrinker, language.lang);

      setSelectOptions({
        workExperience: {
          select: _workExperienceSelect,
          lessThan1Month: _lessThan1Month,
          lessThan3Months: _lessThan3Months,
          lessThan6Months: _lessThan6Months,
          lessThan1Year: _lessThan1Year,
          lessThan3Years: _lessThan3Years,
          lessThan5Years: _lessThan5Years,
          moreThan5Years: _moreThan5Years,
        },
        smoking: {
          select: _smokingSelect,
          smoker: _smoker,
          nonSmoker: _nonSmoker,
        },
        drinking: {
          select: _drinkingSelect,
          drinker: _drinker,
          nonDrinker: _nonDrinker,
        },
      });
    } catch (e) {
      console.log("Init Error: ", e);
    }
  };

  // 보건 카드 조회
  const Search = async (_param = userInfo.userId) => {
    try {
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.HealthSafety, {
        companyCode: location.state.company?.companyCode,
        siteId: location.state.site?.siteId,
        empId: _param,
      });
      console.log("Search response: ", response);

      if (!response) {
        setFormData({
          jobDate: "", // 작업 예정일
          siteId: "",
          siteName: "",
          eduId: "",
          constructionTypeList: [],
          constructionTypes: [],
          unitList: [],
          units: [],
          address: "", // 주소
          emergencyPhone: "", // 비상연락처
          highBloodPressure: "", // 최고 혈압
          lowBloodPressure: "", // 최저 혈압
          workExperience: "0", // 경력
          smoking: "0", // 흡연 여부
          drinking: "0", // 음주 여부
          healthCheck: [],
          ppeIssueStatus: [],
          safeAgreement: [],
          pledgeConfirmed: false, // 안전 서약서 동의 여부
        });
        return { healthCheck: [], ppeIssueStatus: [] };
      } else if (response.status === 404) {
        setFormData({
          jobDate: "", // 작업 예정일
          siteId: "",
          siteName: "",
          eduId: "",
          constructionTypeList: [],
          constructionTypes: [],
          unitList: [],
          units: [],
          address: "", // 주소
          emergencyPhone: "", // 비상연락처
          highBloodPressure: "", // 최고 혈압
          lowBloodPressure: "", // 최저 혈압
          workExperience: "0", // 경력
          smoking: "0", // 흡연 여부
          drinking: "0", // 음주 여부
          healthCheck: [],
          ppeIssueStatus: [],
          safeAgreement: [],
          pledgeConfirmed: false, // 안전 서약서 동의 여부
        });
        return { healthCheck: [], ppeIssueStatus: [] };
      } else if (response.status === 200) {
        const responseData = response.data;
        // healthCheck와 ppeIssueStatus가 배열인지 확인
        if (responseData.healthCheck && !Array.isArray(responseData.healthCheck)) {
          responseData.healthCheck = [];
        }
        if (responseData.ppeIssueStatus && !Array.isArray(responseData.ppeIssueStatus)) {
          responseData.ppeIssueStatus = [];
        }

        setFormData((prev) => ({
          ...prev,
          ...responseData,
          eduId: location.state.site.id,
        }));
        return { healthCheck: responseData.healthCheck || [], ppeIssueStatus: responseData.ppeIssueStatus || [] };
      } else {
        throw new Error(response.data);
      }
    } catch (e) {
      console.log("Search error: ", e);
      return { healthCheck: [], ppeIssueStatus: [] };
    } finally {
      setLoading(false);
    }
  };

  const Search1 = async (_type = "health", searchData = null) => {
    try {
      let param = "";
      if (_type === "health") {
        const healthCheckData = searchData?.healthCheck || formData.healthCheck;
        if (Array.isArray(healthCheckData) && healthCheckData.length > 0) {
          return;
        }
        param = "health_check";
      } else if (_type === "ppe") {
        const ppeIssueStatusData = searchData?.ppeIssueStatus || formData.ppeIssueStatus;
        if (Array.isArray(ppeIssueStatusData) && ppeIssueStatusData.length > 0) {
          return;
        }
        param = "ppe_issue";
      } else {
        param = "safe_agreement";
      }
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.FormConfig, {
        companyCode: location.state.company?.companyCode,
        siteId: location.state.site?.siteId,
        formType: param,
      });
      console.log(`Search1 ${_type} response: `, response);

      if (!response) {
        if (_type === "health") {
          setFormData((prev) => ({
            ...prev,
            healthCheck: [],
          }));
        } else if (_type === "ppe") {
          setFormData((prev) => ({
            ...prev,
            ppeIssueStatus: [],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            safeAgreement: [],
          }));
        }
      } else if (response.status === 404) {
        if (_type === "health") {
          setFormData((prev) => ({
            ...prev,
            healthCheck: [],
          }));
        } else if (_type === "ppe") {
          setFormData((prev) => ({
            ...prev,
            ppeIssueStatus: [],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            safeAgreement: [],
          }));
        }
      } else if (response.status === 200) {
        if (_type === "health") {
          let _healthCheck = response.data.formSchema;
          if (Array.isArray(_healthCheck)) {
            _healthCheck.forEach((item) => {
              item.checked = "";
            });
            if (!Array.isArray(formData.healthCheck) || formData.healthCheck.length < 1) {
              setFormData((prev) => ({
                ...prev,
                healthCheck: _healthCheck,
              }));
            }
          } else {
            setFormData((prev) => ({
              ...prev,
              healthCheck: [],
            }));
          }
        } else if (_type === "ppe") {
          let _ppeIssueStatus = response.data.formSchema;
          if (Array.isArray(_ppeIssueStatus)) {
            _ppeIssueStatus.forEach((item) => {
              item.checked = "";
            });
            if (!Array.isArray(formData.ppeIssueStatus) || formData.ppeIssueStatus.length < 1) {
              setFormData((prev) => ({
                ...prev,
                ppeIssueStatus: _ppeIssueStatus,
              }));
            }
          } else {
            setFormData((prev) => ({
              ...prev,
              ppeIssueStatus: [],
            }));
          }
        } else {
          setFormData((prev) => ({
            ...prev,
            safeAgreement: response.data.formSchema || [],
          }));
        }
      } else {
        throw new Error(response.data);
      }
    } catch (e) {
      console.log("Search1 error: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 교육 승인 요청 로직
  const Sumit = async () => {
    try {
      if (!formData.address) {
        Swal.warning("주소를 입력해주세요.");
        return;
      }
      if (!formData.highBloodPressure) {
        Swal.warning("혈압을 입력해주세요.");
        return;
      }
      if (!formData.lowBloodPressure) {
        Swal.warning("혈압을 입력해주세요.");
        return;
      }
      if (formData.workExperience === "0") {
        Swal.warning("경력을 선택해주세요.");
        return;
      }
      if (formData.smoking === "0") {
        Swal.warning("흡연 여부를 선택해주세요.");
        return;
      }
      if (formData.drinking === "0") {
        Swal.warning("음주 여부를 선택해주세요.");
        return;
      }
      // healthCheck 배열의 필수 항목 검증
      if (Array.isArray(formData.healthCheck)) {
        const unCheckedRequiredHealth = formData.healthCheck.find((item) => item.required === true && item.checked === "");
        if (unCheckedRequiredHealth) {
          Swal.warning(`개인 건강 면담 사항에서 "${unCheckedRequiredHealth.label}" 항목을 선택해주세요.`);
          return;
        }
      }
      // ppeIssueStatus 배열의 필수 항목 검증
      if (Array.isArray(formData.ppeIssueStatus)) {
        const unCheckedRequiredPpe = formData.ppeIssueStatus.find((item) => item.required === true && item.checked === "");
        if (unCheckedRequiredPpe) {
          Swal.warning(`보호구 지급 품목에서 "${unCheckedRequiredPpe.label}" 항목을 선택해주세요.`);
          return;
        }
      }
      if (!formData.pledgeConfirmed) {
        Swal.warning("안전 서약서를 동의해주세요.");
        return;
      }
      setLoading(true);
      let params = {
        siteId: location.state.site?.siteId,
        companyCode: location.state.company.companyCode,
        empId: userInfo.userId,
        eduId: formData.eduId,
        jobDate: formData.jobDate,
        address: formData.address,
        phone: userInfo.tel ?? "",
        emergencyPhone: formData.emergencyPhone,
        highBloodPressure: formData.highBloodPressure,
        lowBloodPressure: formData.lowBloodPressure,
        workExperience: formData.workExperience,
        smoking: formData.smoking,
        drinking: formData.drinking,
        healthCheck: formData.healthCheck,
        ppeIssueStatus: formData.ppeIssueStatus,
        constructionTypes: formData.constructionTypes,
        units: formData.units,
        pledgeConfirmed: formData.pledgeConfirmed,
      };
      console.log("Sumit params: ", params);
      await Commons.Axios("post", Global.base.useUrl + Global.urls.Content.HealthSafety, {}, JSON.stringify(params)).then((result) => {
        let data = result.data;
        console.log("Sumit: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Swal.success("보건 서류 작성이 완료되었습니다.").then(() => {
            navigate("/composed-education", { state: { company: location.state.company, site: [] } });
          });
        }
      });
    } catch (e) {
      console.log("Sumit Error: ", e);
    } finally {
      setLoading(false);
    }
  };

  const HandleReceivePost = (data) => {
    console.log("HandleReceivePost data: ", data);
    setFormData((prev) => ({
      ...prev,
      address: data.address,
    }));
    setDialog(false);
  };

  // 건강 면담 답변 처리
  const handleHealthAnswer = (questionId, answer) => {
    if (!Array.isArray(formData.healthCheck)) {
      return;
    }
    const updatedQuestions = formData.healthCheck.map((item) => (item.id === questionId ? { ...item, checked: answer } : item));
    setFormData((prev) => ({
      ...prev,
      healthCheck: updatedQuestions,
    }));
  };

  // 건강 면담 기타 입력 처리
  const handleHealthNote = (questionId, note) => {
    if (!Array.isArray(formData.healthCheck)) {
      return;
    }
    const updatedQuestions = formData.healthCheck.map((item) => (item.id === questionId ? { ...item, note: note } : item));
    setFormData((prev) => ({
      ...prev,
      healthCheck: updatedQuestions,
    }));
  };

  // 보호구 지급 상태 처리
  const handleEquipmentStatus = (equipmentId, status) => {
    if (!Array.isArray(formData.ppeIssueStatus)) {
      return;
    }
    const updatedEquipment = formData.ppeIssueStatus.map((item) => (item.id === equipmentId ? { ...item, checked: status } : item));
    setFormData((prev) => ({
      ...prev,
      ppeIssueStatus: updatedEquipment,
    }));
  };

  // 보호구 지급 품목 기타 입력 처리
  const handleEquipmentNote = (equipmentId, note) => {
    if (!Array.isArray(formData.ppeIssueStatus)) {
      return;
    }
    const updatedEquipment = formData.ppeIssueStatus.map((item) => (item.id === equipmentId ? { ...item, note: note } : item));
    setFormData((prev) => ({
      ...prev,
      ppeIssueStatus: updatedEquipment,
    }));
  };

  return (
    <div className='wrapper'>
      {loading && <Loading />}
      <div className='flex-column-center mb-3'>
        <div className='flex-end w-100 my-3'>
          <Button className='flex-center-center gap-1 btn-primary' onClick={Sumit}>
            <FontAwesomeIcon icon={faSave} />
            <AutoTranslate targetLanguage={language.lang}>보건 서류 저장</AutoTranslate>
          </Button>
        </div>
        <Form className='w-100' onSubmit={(e) => e.preventDefault()}>
          <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>성명</AutoTranslate>
              </Form.Label>
              <Form.Control type='text' value={userInfo.userNm || ""} disabled />
            </Form.Group>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>생년월일</AutoTranslate>
              </Form.Label>
              <Form.Control type='text' value={userInfo.birth ?? ""} disabled />
            </Form.Group>
          </div>
          <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>연락처</AutoTranslate>
              </Form.Label>
              <Form.Control type='text' value={userInfo.tel ?? ""} disabled />
            </Form.Group>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>비상연락처</AutoTranslate>
              </Form.Label>
              <Form.Control
                type='tel'
                placeholder={wording.placeholder2}
                value={formData.emergencyPhone}
                onChange={(e) => setFormData({ ...formData, emergencyPhone: Commons.FormatPhoneNumber(e.target.value) })}
              />
            </Form.Group>
          </div>
          <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
            <Form.Group className='w-100'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>주소</AutoTranslate>
                <span style={{ color: "#dc3545" }}>&#42;</span>
              </Form.Label>
              <Form.Control type='text' placeholder={wording.placeholder3} value={formData.address} onClick={() => setDialog1(true)} readOnly />
            </Form.Group>
          </div>
          <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>최고 혈압 (기준: 150미만)</AutoTranslate>
                <span style={{ color: "#dc3545" }}>&#42;</span>
              </Form.Label>
              <Form.Control type='number' placeholder={wording.placeholder4} value={formData.highBloodPressure} onChange={(e) => setFormData({ ...formData, highBloodPressure: e.target.value })} />
            </Form.Group>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>최저 혈압 (기준: 90미만)</AutoTranslate>
                <span style={{ color: "#dc3545" }}>&#42;</span>
              </Form.Label>
              <Form.Control type='number' placeholder={wording.placeholder5} value={formData.lowBloodPressure} onChange={(e) => setFormData({ ...formData, lowBloodPressure: e.target.value })} />
            </Form.Group>
          </div>
          <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
            <Form.Group className='w-100'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>경력 선택</AutoTranslate>
                <span style={{ color: "#dc3545" }}>&#42;</span>
              </Form.Label>
              <Form.Select value={formData.workExperience} onChange={(e) => setFormData({ ...formData, workExperience: e.target.value })}>
                <option value='0'>{selectOptions.workExperience.select}</option>
                <option value='1'>{selectOptions.workExperience.lessThan1Month}</option>
                <option value='3'>{selectOptions.workExperience.lessThan3Months}</option>
                <option value='6'>{selectOptions.workExperience.lessThan6Months}</option>
                <option value='12'>{selectOptions.workExperience.lessThan1Year}</option>
                <option value='36'>{selectOptions.workExperience.lessThan3Years}</option>
                <option value='60'>{selectOptions.workExperience.lessThan5Years}</option>
                <option value='61'>{selectOptions.workExperience.moreThan5Years}</option>
              </Form.Select>
            </Form.Group>
          </div>
          <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>흡연 여부</AutoTranslate>
                <span style={{ color: "#dc3545" }}>&#42;</span>
              </Form.Label>
              <Form.Select value={formData.smoking} onChange={(e) => setFormData({ ...formData, smoking: e.target.value })}>
                <option value='0'>{selectOptions.smoking.select}</option>
                <option value={true}>{selectOptions.smoking.smoker}</option>
                <option value={false}>{selectOptions.smoking.nonSmoker}</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className='w-50'>
              <Form.Label style={{ fontSize: "1rem", fontWeight: "600" }}>
                <AutoTranslate targetLanguage={language.lang}>음주 여부</AutoTranslate>
                <span style={{ color: "#dc3545" }}>&#42;</span>
              </Form.Label>
              <Form.Select value={formData.drinking} onChange={(e) => setFormData({ ...formData, drinking: e.target.value })}>
                <option value='0'>{selectOptions.drinking.select}</option>
                <option value={true}>{selectOptions.drinking.drinker}</option>
                <option value={false}>{selectOptions.drinking.nonDrinker}</option>
              </Form.Select>
            </Form.Group>
          </div>
        </Form>
        <div className={`${Commons.IsMobile() ? "flex-column-center gap-4 w-100" : "flex-between gap-3 w-100 px-2"}`}>
          <div className={`${Commons.IsMobile() ? "w-100" : "w-50"}`}>
            <p style={{ fontSize: "1rem", fontWeight: "600" }}>
              <AutoTranslate targetLanguage={language.lang}>개인 건강 면담 사항</AutoTranslate>
            </p>
            <div className='w-100'>
              {Array.isArray(formData.healthCheck) &&
                formData.healthCheck?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className='flex-between-center gap-1 w-100 mb-2 px-2'>
                        <div style={{ fontSize: "1rem" }}>
                          <AutoTranslate targetLanguage={language.lang}>{item.label}</AutoTranslate>
                        </div>
                        <ButtonGroup>
                          <Button variant={item.checked === true ? "primary" : "outline-primary"} style={{ width: "80px" }} onClick={() => handleHealthAnswer(item.id, true)}>
                            <AutoTranslate targetLanguage={language.lang}>예</AutoTranslate>
                          </Button>
                          <Button variant={item.checked === false ? "primary" : "outline-primary"} style={{ width: "80px" }} onClick={() => handleHealthAnswer(item.id, false)}>
                            <AutoTranslate targetLanguage={language.lang}>아니오</AutoTranslate>
                          </Button>
                        </ButtonGroup>
                      </div>
                      {item.hasNote === true && item.checked === true && (
                        <Form className='w-100 mb-2 px-2' onSubmit={(e) => e.preventDefault()}>
                          <Form.Group className='w-100'>
                            <Form.Control type='text' placeholder={wording.placeholder1} value={item.note ?? ""} onChange={(e) => handleHealthNote(item.id, e.target.value)} />
                          </Form.Group>
                        </Form>
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
          <div className={`${Commons.IsMobile() ? "w-100" : "w-50"}`}>
            <p style={{ fontSize: "1rem", fontWeight: "600" }}>
              <AutoTranslate targetLanguage={language.lang}>보호구 지급 품목</AutoTranslate>
            </p>
            <div className='w-100'>
              {Array.isArray(formData.ppeIssueStatus) &&
                formData.ppeIssueStatus?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className='flex-between-center gap-1 w-100 mb-2 px-2'>
                        <div style={{ fontSize: "1rem" }}>
                          <AutoTranslate targetLanguage={language.lang}>{item.label}</AutoTranslate>
                        </div>
                        <ButtonGroup>
                          <Button variant={item.checked === true ? "primary" : "outline-primary"} style={{ width: "80px" }} onClick={() => handleEquipmentStatus(item.id, true)}>
                            <AutoTranslate targetLanguage={language.lang}>지급</AutoTranslate>
                          </Button>
                          <Button variant={item.checked === false ? "primary" : "outline-primary"} style={{ width: "80px" }} onClick={() => handleEquipmentStatus(item.id, false)}>
                            <AutoTranslate targetLanguage={language.lang}>미지급</AutoTranslate>
                          </Button>
                        </ButtonGroup>
                      </div>
                      {item.hasNote === true && item.checked === true && (
                        <Form className='w-100 mb-2 px-2' onSubmit={(e) => e.preventDefault()}>
                          <Form.Group className='w-100'>
                            <Form.Control type='text' placeholder={wording.placeholder1} value={item.note ?? ""} onChange={(e) => handleEquipmentNote(item.id, e.target.value)} />
                          </Form.Group>
                        </Form>
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
        </div>
        <div className='flex-center-center w-100 mt-3'>
          <Button className={`w-100 ${!formData.pledgeConfirmed && "btn-primary"}`} variant={formData.pledgeConfirmed && "success"} onClick={() => setDialog(true)}>
            {formData.pledgeConfirmed && <FontAwesomeIcon className='me-2' icon={faCircleCheck} />}
            {formData.pledgeConfirmed ? (
              <AutoTranslate targetLanguage={language.lang}>안전 서약서 확인 완료</AutoTranslate>
            ) : (
              <AutoTranslate targetLanguage={language.lang}>안전 서약서 확인하기</AutoTranslate>
            )}
          </Button>
        </div>
        <div className='my-5 divider' />
      </div>
      <Dialog
        show={dialog}
        onHide={() => setDialog(false)}
        title={`${location.state.company?.companyName} 안전 서약서`}
        footerChildren={
          <div className='flex-between-center w-100'>
            <div />
            <Form onSubmit={(e) => e.preventDefault()}>
              <Form.Group className='w-100'>
                <Form.Check
                  id='safetyAgreement'
                  className='custom-checkbox'
                  type='checkbox'
                  label={wording.label}
                  checked={formData.pledgeConfirmed}
                  onChange={(e) => setFormData((prev) => ({ ...prev, pledgeConfirmed: e.target.checked }))}
                />
              </Form.Group>
            </Form>
            <Button className='btn-primary' onClick={() => setDialog(false)} disabled={!formData.pledgeConfirmed}>
              <AutoTranslate targetLanguage={language.lang}>확인</AutoTranslate>
            </Button>
          </div>
        }
      >
        <div style={{ height: "50vh", overflowY: "auto" }}>
          <div className='w-100'>
            {Array.isArray(formData.safeAgreement) &&
              formData.safeAgreement?.map((item, index) => {
                return (
                  <p key={index} style={{ fontSize: "1rem", fontWeight: "600" }}>
                    <AutoTranslate targetLanguage={language.lang}>{`${index + 1}. ${item.label}`}</AutoTranslate>
                  </p>
                );
              })}
            <div className='flex-column-center w-100'>
              <p>
                <AutoTranslate targetLanguage={language.lang}>본 근로자는 당 현장에서 근무하는 기간동안 산업안전보건법 제25조 근로자 준수사항에 의거한 안전사항과</AutoTranslate>
              </p>
              <p>
                <AutoTranslate targetLanguage={language.lang}>{`${location.state.company?.companyName} 안전규칙을 성실하고 철저하게 준수할 것이며 위 각호의 사항 중 어느 하나라도`}</AutoTranslate>
              </p>
              <p>
                <AutoTranslate targetLanguage={language.lang}>미이행 시 발생하는 모든 손실에 대한 책임(민,형사상)은 본인에게 귀속됨을 동의합니다.</AutoTranslate>
              </p>
            </div>
          </div>
        </div>
      </Dialog>
      <KakaoAddress show={dialog1} onHide={() => setDialog1(false)} onReceivePost={HandleReceivePost} />
    </div>
  );
}

export default HealthDocument;
